import { render } from "./JotForm.vue?vue&type=template&id=e870e5ac&scoped=true"
import script from "./JotForm.vue?vue&type=script&lang=js"
export * from "./JotForm.vue?vue&type=script&lang=js"

import "./JotForm.vue?vue&type=style&index=0&id=e870e5ac&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e870e5ac"]])

export default __exports__